import React from "react";
import "./hero.css";
import { useNavigate } from 'react-router-dom';

const Hero = () => {
    const navigate = useNavigate();

    const handleClick = () => {
        navigate('/dashboard');
    };
    return (
        <div className="container">
            <div className="text-section">
                <h1>Unlock Industry Insights with Deep Analysis</h1>
                <p>
                    Get comprehensive insights into companies, sectors, and value chains.
                    Make informed decisions with our detailed analysis and industry
                    expertise.
                </p>
                <div className="buttons">
                    <button className="primary-btn" onClick={handleClick}>Start Analyzing</button>
                </div>
            </div>
            <div className="image-section"></div>
        </div>
    );
};

export default Hero;
